import PageTemplate from "../components/common/PageTemplate"
import ChangeProfile from "../screen/profile/ChangeProfile";

const ChangeProfilePage = () => {
  return (
    <PageTemplate
      mainComponent={<ChangeProfile />}
      noPadding={true}
      logo={"Ubah Profil"}
    />
  );
}

export default ChangeProfilePage
